module.exports = __webpack_public_path__ + "static/img/banner.1941680.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/qipai/banner.png
// module id = fuop
// module chunks = 3